import type { FaireBrandEntity } from "../../entity_types/brand";

// Oggi — real Faire brand (b_chwjy424g8). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "Oggi" real-brand
// variant (advertiser 4748191580351722375).
export const b_chwjy424g8: FaireBrandEntity = {
  token: "b_chwjy424g8",
  type: "brand",
  name: "Oggi",
  description:
    "Kitchen and tabletop goods — dish racks, canisters, and barware.",
  location: "Anaheim, CA, USA",
  isTopShop: false,
  tags: ["home-decor", "kitchen-tabletop", "housewares"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
